import { DialogType } from '@/enums/dialogType'
import api from '@/services/api'

export default {
    namespaced: true,
    state: {
        stock: {},
        lstStock: [],
        isUpdate: false,
        shouldReload: false,
        search: "",
        itemsPerPage: 25,
        hasNext: false,
        page: 1,
        totalItems: 0,
        headers: [
            { title: 'ESTOQUE', key: 'stockName', align: 'center' }
        ],
    },
    getters: {
        getStock(state) {
            let stock = { ...state.stock }
            return stock
        }
    },
    mutations: {
        setStock(state, stock) {
            state.stock = stock
        },
        setLstStock(state, lstStock) {
            state.lstStock = lstStock
        },
        appendLstStock(state, items) {
            state.lstStock = [...state.lstStock, ...items]
        },
        clearLstStock(state) {
            state.lstStock = []
        },
        setPage(state, page) {
            state.page = page
        },
        setHasNext(state, hasNext) {
            state.hasNext = hasNext
        },
        setTotalItems(state, total) {
            state.totalItems = total
        },
        setShouldReload(state, reload) {
            state.shouldReload = reload
        },
        initForm(state) {
            state.isUpdate = false
            state.stock = {}
            state.search = ''
        },
        setUpdating(state) {
            state.isUpdate = true
        }
    },
    actions: {
        async save({ state, dispatch }) {
            if (state.isUpdate) {
                return await dispatch('update')
            }
            else
                return await dispatch('insert')
        },

        async insert({ getters, dispatch }) {
            await api.post(
                '/Stock/Insert',
                getters.getStock
            )

            dispatch('systemDialog/show', {
                type: DialogType.SUCCESS,
                message: 'Estoque salvo'
            }, { root: true })

            return true
        },

        async update({ getters, dispatch }) {
            await api.put(
                '/Stock/Update',
                getters.getStock
            )

            dispatch('systemDialog/show', {
                type: DialogType.SUCCESS,
                message: 'Estoque atualizado'
            }, { root: true })

            return true
        },

        async search({ state, commit }, { search, limit = 25, page = 1, reset}) {
            let searchParam = search || state.search
            const response = await api.get(
                `/Stock/Search?search=${searchParam}&limit=${limit}&page=${page}`
            )

            if (reset) {
                commit("setLstStock", response.data.items)
            } else {
                commit("appendLstStock", response.data.items)
            }

            commit('setHasNext', response.data.hasNext)
            commit('setTotalItems', response.data.totalCount)
            commit('setPage', page)
            
            return true
        },

        async find({commit}, stockId) {
            const response = await api.get(
                `/Stock/Find/${stockId}`,
            )
            commit('setStock', response.data)
            commit('setUpdating')

            return true
        },

        async findAll({ commit }) {
            const response = await api.get(
                `/Stock/FindAll/`,
            )
            commit('setLstStock', response.data)
            
            return true
        },

        async delete({ getters, dispatch }) {
            await api.delete(
                `/Stock/Delete/${getters.getStock.stockId}`,
            )
            dispatch('systemDialog/show', {
                type: DialogType.SUCCESS,
                message: 'Registro deletado com sucesso!'
            }, { root: true })

            return true
        },

        async downloadStockReport(context, payload) {

            const response = await api.get(`/StockBalance/GetStockReport`, {
                params: payload,
                responseType: 'blob'
            })

            const blob = new Blob([response.data], { type: 'application/pdf' })
            const url = window.URL.createObjectURL(blob)

            const link = document.createElement('a')
            link.href = url
            link.download = `Relatorio_Estoque_${new Date()}.pdf`
            document.body.appendChild(link)
            link.click()

            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)
        }
    }
}